import { createColumnHelper } from '@tanstack/react-table'
import { Victimology } from '../../types/StatTypes'

export const victimologyColumns = () => {
  const columnHelper = createColumnHelper<Victimology>()

  return [
    columnHelper.accessor('spyware', {
      header: 'Spyware',
      maxSize: 100,
      enableSorting: true,
    }),
    columnHelper.accessor('spywareVersion', {
      header: 'Version',
      enableSorting: true,
    }),
    columnHelper.accessor('detectedBy', {
      header: 'Detected By',
      enableSorting: true,
    }),
    columnHelper.accessor('dateDetected', {
      header: 'Detected',
      enableSorting: true,
    }),
    columnHelper.accessor('dateInfected', {
      header: 'Infected',
      enableSorting: true,
    }),
    columnHelper.accessor('targetIndustry', {
      header: 'Tgt. Industry',
      enableSorting: true,
    }),
    columnHelper.accessor('targetCountry', {
      header: 'Tgt. Country',
      enableSorting: true,
    }),
    columnHelper.accessor('sourceCountry', {
      header: 'Src. Country',
      enableSorting: true,
    }),
    columnHelper.accessor('confidenceRating', {
      header: 'Src. Confidence',
      enableSorting: true,
    }),
    columnHelper.accessor('recievedApple', {
      header: 'Notified by Apple',
      enableSorting: true,
    }),
    columnHelper.accessor('reason', {
      header: 'Tgt. Reason',
      enableSorting: true,
    }),
    columnHelper.accessor('targetRatingConfidence', {
      header: 'Reason Confidence',
      enableSorting: true,
    }),
  ]
}
